module.exports = __webpack_public_path__ + "static/media/Bottom.1b44f52f.png";